module.exports = __webpack_public_path__ + "img/15.2c43ff73.jpg";